import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CampaignsEntity } from '../../domain/entities/CampaignsEntity'
import type { CampaignAdminDto } from '@/backend/market'

export class CampaignsModel extends CampaignsEntity {
  constructor(dataDto: CampaignAdminDto) {
    super()
    mapEntityProperties<CampaignsEntity>(this, dataDto, {
      map: {
        steps: dataDto.steps?.map((step) => ({
          index: step.index,
          type: step.type,
          value: step.value,
          maxDiscountAllowed: step.maxDiscountAllowed,
          appliedTo: step.appliedTo,
          minCartAmount: step.minCartAmount,
          defaultServiceRatio: step.defaultServiceRatio,
          defaultBranchRatio: step.defaultBranchRatio,
          limitedDefaultBranchShareAmount: step.limitedDefaultBranchShareAmount,
          bonusPoints: step.loyaltyProgramBonus?.bonusPoints,
          bonusMultiplier: step.loyaltyProgramBonus?.bonusMultiplier,
          isActive: step.loyaltyProgramBonus?.isActive,
          branches: step.branchRatios?.map((branchData) => ({
            branch: {
              id: branchData.branchId,
              name: branchData.branchName
            },
            serviceRatio: branchData.serviceRatio,
            branchRatio: branchData.branchRatio,
            limitedBranchShareAmount: branchData.limitedBranchShareAmount,
            shareType: branchData.limitedBranchShareAmount ? 'Amount' : 'Ratio'
          }))
        }))
      }
    })
  }
}
